



































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Spinner extends Vue {
  @Prop({ default: "#f3aa45" })
  public color!: string;
}
